import { Type } from "class-transformer";
import { IsOptional } from "class-validator";
import { TemplateGoodsRecipientFieldDto } from "./template-goods-recipient-field.dto";

export class TemplateGoodsRecipientDto {
  @IsOptional()
  @Type(() => TemplateGoodsRecipientFieldDto)
  information?: TemplateGoodsRecipientFieldDto;
}
